export default "__VITE_ASSET__CRlxurBN__"